/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Anagrafica } from '../model/anagrafica';
import { ComuneViewDTO } from '../model/comuneViewDTO';
import { ComunicazionGenitoriForm } from '../model/comunicazionGenitoriForm';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';
import { GetScuolaView } from '../model/getScuolaView';
import { GetUserProfileDTO } from '../model/getUserProfileDTO';
import { PageUserViewImpl } from '../model/pageUserViewImpl';
import { PushTokenDTO } from '../model/pushTokenDTO';
import { ScuolaGestitaDTO } from '../model/scuolaGestitaDTO';
import { StoricoIseeResponseDTO } from '../model/storicoIseeResponseDTO';
import { UpdateStoricoIseeForm } from '../model/updateStoricoIseeForm';
import { User } from '../model/user';
import { UserModificationForm } from '../model/userModificationForm';
import { UserRegistrationForm } from '../model/userRegistrationForm';
import { UserType } from '../model/userType';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UtentiService {

    protected basePath = 'https://demo-api.mensapp.it/gestione-mense';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Attiva/blocca un account utente a partire dal suo identificativo. Se bloccato, tutti i token associati all&#x27;utente vengono invalidati.
     * Abilita o blocca l&#x27;account di un utente. In caso di blocco, tutti i token JWT attivi vengono invalidati. Accessibile agli utenti ADMIN.
     * @param user_id Identificativo dell&#x27;utente da attivare. Non può essere nullo o vuoto.
     * @param activate Valore di abilitazione dell&#x27;utente. Se settato a true, l&#x27;utente viene abilitato. Se settato a false, l&#x27;utente viene bloccato. Non può essere nullo o vuoto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public activateOrLockAccount(user_id: string, activate: boolean, observe?: 'body', reportProgress?: boolean): Observable<User>;
    public activateOrLockAccount(user_id: string, activate: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<User>>;
    public activateOrLockAccount(user_id: string, activate: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<User>>;
    public activateOrLockAccount(user_id: string, activate: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling activateOrLockAccount.');
        }

        if (activate === null || activate === undefined) {
            throw new Error('Required parameter activate was null or undefined when calling activateOrLockAccount.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (activate !== undefined && activate !== null) {
            queryParameters = queryParameters.set('activate', <any>activate);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<User>('put',`${this.basePath}/api/v1/user/${encodeURIComponent(String(user_id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Cancella il lockout brute force di un utente in Keycloak.
     * Sblocca un operatore bloccato da Keycloak per troppi tentativi di login falliti. Accessibile solo agli utenti ADMIN.
     * @param user_id Identificativo dell&#x27;utente da sbloccare.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clearBruteForceLockout(user_id: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public clearBruteForceLockout(user_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public clearBruteForceLockout(user_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public clearBruteForceLockout(user_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling clearBruteForceLockout.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('delete',`${this.basePath}/api/v1/user/${encodeURIComponent(String(user_id))}/brute-force-lockout`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente la rimozione del push token.
     * Rimuove il token Firebase per le notifiche push associato al dispositivo specificato.
     * @param userId 
     * @param idDevice 
     * @param pushToken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deletePushToken(userId: string, idDevice: string, pushToken: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public deletePushToken(userId: string, idDevice: string, pushToken: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public deletePushToken(userId: string, idDevice: string, pushToken: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public deletePushToken(userId: string, idDevice: string, pushToken: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling deletePushToken.');
        }

        if (idDevice === null || idDevice === undefined) {
            throw new Error('Required parameter idDevice was null or undefined when calling deletePushToken.');
        }

        if (pushToken === null || pushToken === undefined) {
            throw new Error('Required parameter pushToken was null or undefined when calling deletePushToken.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }
        if (idDevice !== undefined && idDevice !== null) {
            queryParameters = queryParameters.set('idDevice', <any>idDevice);
        }
        if (pushToken !== undefined && pushToken !== null) {
            queryParameters = queryParameters.set('pushToken', <any>pushToken);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/user/deletePushToken`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rimuove un utente a partire dal suo identificativo e ne invalida tutti gli eventuali token.
     * Elimina l&#x27;account di un utente dal sistema e invalida tutti i token JWT attivi associati. Accessibile agli utenti ADMIN.
     * @param user_id Identificativo dell&#x27;utente da rimuovere. Non può essere nullo o vuoto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteUser(user_id: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public deleteUser(user_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public deleteUser(user_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public deleteUser(user_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling deleteUser.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('delete',`${this.basePath}/api/v1/user/${encodeURIComponent(String(user_id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account Amministratore di modificare i comuni o le scuole gestite da un utente di tipo OP_COMUNE, OP_SCUOLA, OP_CENTRO_COTTURA.
     * Aggiorna le associazioni di comuni e scuole per un utente operatore esistente. Accessibile solo agli utenti ADMIN.
     * @param body Form di modifica dell&#x27;utente da aggiungere.
     * @param user_id Identificativo dell&#x27;utente da attivare. Non può essere nullo o vuoto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editUser(body: UserModificationForm, user_id: string, observe?: 'body', reportProgress?: boolean): Observable<User>;
    public editUser(body: UserModificationForm, user_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<User>>;
    public editUser(body: UserModificationForm, user_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<User>>;
    public editUser(body: UserModificationForm, user_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling editUser.');
        }

        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling editUser.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<User>('put',`${this.basePath}/api/v1/user/${encodeURIComponent(String(user_id))}/edit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce le anagrafiche dell&#x27;utente autenticato per l&#x27;anno di riferimento corrente, con studenti arricchiti.
     * Restituisce le anagrafiche con studenti, configurazione comune, flag ricariche da pagare e giorni residui alla sospensione del servizio.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAnagraficheUtente(observe?: 'body', reportProgress?: boolean): Observable<Array<Anagrafica>>;
    public getAnagraficheUtente(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Anagrafica>>>;
    public getAnagraficheUtente(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Anagrafica>>>;
    public getAnagraficheUtente(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Anagrafica>>('get',`${this.basePath}/api/v1/user/anagrafiche`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce la lista dei comuni collegati all&#x27;utente.
     * Restituisce l&#x27;elenco dei comuni gestiti dall&#x27;utente autenticato corrente.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getComuniUtente(observe?: 'body', reportProgress?: boolean): Observable<Array<ComuneViewDTO>>;
    public getComuniUtente(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ComuneViewDTO>>>;
    public getComuniUtente(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ComuneViewDTO>>>;
    public getComuniUtente(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ComuneViewDTO>>('get',`${this.basePath}/api/v1/user/comuni`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere il link di reset password di un account.
     * Genera e restituisce il link di reset password per l&#x27;utente specificato. Accessibile agli utenti ADMIN.
     * @param user_id Identificativo dell&#x27;utente per cui richiedere il link di reset password. Non può essere nullo o vuoto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getResetPasswordMailLink(user_id: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public getResetPasswordMailLink(user_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public getResetPasswordMailLink(user_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public getResetPasswordMailLink(user_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling getResetPasswordMailLink.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('get',`${this.basePath}/api/v1/user/${encodeURIComponent(String(user_id))}/get-reset-password-link`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce le scuole gestite dall&#x27;utente con calendario scolastico e chiusure.
     * Restituisce l&#x27;elenco delle scuole gestite dall&#x27;utente autenticato, incluso il calendario scolastico con le relative chiusure. Endpoint dedicato per operatori scolastici. Usare GET /api/v1/user/scuole per la lista leggera con filtro per comune.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScuoleGestite(observe?: 'body', reportProgress?: boolean): Observable<Array<ScuolaGestitaDTO>>;
    public getScuoleGestite(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ScuolaGestitaDTO>>>;
    public getScuoleGestite(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ScuolaGestitaDTO>>>;
    public getScuoleGestite(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ScuolaGestitaDTO>>('get',`${this.basePath}/api/v1/user/scuole-gestite`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce la lista delle scuole collegate all&#x27;utente.
     * Restituisce l&#x27;elenco delle scuole collegate all&#x27;utente autenticato corrente (projection leggera senza calendario), con possibilità di filtrare per comune. Usare GET /api/v1/user/scuole-gestite per includere calendario e chiusure.
     * @param slugComune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScuoleUtente(slugComune?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<GetScuolaView>>;
    public getScuoleUtente(slugComune?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GetScuolaView>>>;
    public getScuoleUtente(slugComune?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GetScuolaView>>>;
    public getScuoleUtente(slugComune?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<GetScuolaView>>('get',`${this.basePath}/api/v1/user/scuole`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce lo storico ISEE di un&#x27;anagrafica.
     * Restituisce la lista storica delle fasce ISEE associate all&#x27;anagrafica specificata, ordinate per data di validità.
     * @param anagrafica_id Identificativo dell&#x27;anagrafica. Non può essere nullo o vuoto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStoricoIsee(anagrafica_id: string, observe?: 'body', reportProgress?: boolean): Observable<StoricoIseeResponseDTO>;
    public getStoricoIsee(anagrafica_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StoricoIseeResponseDTO>>;
    public getStoricoIsee(anagrafica_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StoricoIseeResponseDTO>>;
    public getStoricoIsee(anagrafica_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (anagrafica_id === null || anagrafica_id === undefined) {
            throw new Error('Required parameter anagrafica_id was null or undefined when calling getStoricoIsee.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<StoricoIseeResponseDTO>('get',`${this.basePath}/api/v1/user/${encodeURIComponent(String(anagrafica_id))}/storico-isee`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce il profilo dell&#x27;utente.
     * Restituisce i dati del profilo dell&#x27;utente autenticato corrente.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUser(observe?: 'body', reportProgress?: boolean): Observable<GetUserProfileDTO>;
    public getUser(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserProfileDTO>>;
    public getUser(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserProfileDTO>>;
    public getUser(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserProfileDTO>('get',`${this.basePath}/api/v1/user`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce i profili di tutti gli utenti.
     * Restituisce la lista paginata di tutti gli utenti del sistema per il comune specificato, con possibilità di filtro e ordinamento. Accessibile agli utenti ADMIN.
     * @param slugComune 
     * @param cognome 
     * @param nome 
     * @param codicePratica 
     * @param cellulare 
     * @param email 
     * @param userType 
     * @param accountActivated 
     * @param accountEnabled 
     * @param page Pagina di risultati da estrarre [0..N]
     * @param size Numero di elementi per pagina
     * @param sort Criteri di ordinamento nel formato: {property,(asc|desc)}. L&#x27;ordinamento predefinito è crescente per ordering, sono supportati più criteri di ordinamento.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUsersForm(slugComune: string, cognome?: string, nome?: string, codicePratica?: string, cellulare?: string, email?: string, userType?: UserType, accountActivated?: boolean, accountEnabled?: boolean, page?: number, size?: number, sort?: string, observe?: 'body', reportProgress?: boolean): Observable<PageUserViewImpl>;
    public getUsersForm(slugComune: string, cognome?: string, nome?: string, codicePratica?: string, cellulare?: string, email?: string, userType?: UserType, accountActivated?: boolean, accountEnabled?: boolean, page?: number, size?: number, sort?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageUserViewImpl>>;
    public getUsersForm(slugComune: string, cognome?: string, nome?: string, codicePratica?: string, cellulare?: string, email?: string, userType?: UserType, accountActivated?: boolean, accountEnabled?: boolean, page?: number, size?: number, sort?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageUserViewImpl>>;
    public getUsersForm(slugComune: string, cognome?: string, nome?: string, codicePratica?: string, cellulare?: string, email?: string, userType?: UserType, accountActivated?: boolean, accountEnabled?: boolean, page?: number, size?: number, sort?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling getUsers.');
        }












        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (cognome !== undefined) {
            formParams = formParams.append('cognome', <any>cognome) as any || formParams;
        }
        if (nome !== undefined) {
            formParams = formParams.append('nome', <any>nome) as any || formParams;
        }
        if (codicePratica !== undefined) {
            formParams = formParams.append('codicePratica', <any>codicePratica) as any || formParams;
        }
        if (cellulare !== undefined) {
            formParams = formParams.append('cellulare', <any>cellulare) as any || formParams;
        }
        if (email !== undefined) {
            formParams = formParams.append('email', <any>email) as any || formParams;
        }
        if (userType !== undefined) {
            formParams = formParams.append('userType', <any>userType) as any || formParams;
        }
        if (accountActivated !== undefined) {
            formParams = formParams.append('accountActivated', <any>accountActivated) as any || formParams;
        }
        if (accountEnabled !== undefined) {
            formParams = formParams.append('accountEnabled', <any>accountEnabled) as any || formParams;
        }

        return this.httpClient.request<PageUserViewImpl>('post',`${this.basePath}/api/v1/user/all`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere il link di verifica di un account.
     * Genera e restituisce il link di verifica email per l&#x27;utente specificato. Accessibile agli utenti ADMIN.
     * @param user_id Identificativo dell&#x27;utente per cui richiedere il link di verifica mail. Non può essere nullo o vuoto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVerificationMailLink(user_id: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public getVerificationMailLink(user_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public getVerificationMailLink(user_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public getVerificationMailLink(user_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (user_id === null || user_id === undefined) {
            throw new Error('Required parameter user_id was null or undefined when calling getVerificationMailLink.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('get',`${this.basePath}/api/v1/user/${encodeURIComponent(String(user_id))}/get-verification-link`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account Amministratore di registrare un nuovo utente di tipo OP_COMUNE, OP_SCUOLA, OP_CENTRO_COTTURA.
     * Crea un nuovo utente operatore (OP_COMUNE, OP_SCUOLA o OP_CENTRO_COTTURA) nel sistema. Accessibile solo agli utenti ADMIN.
     * @param body Form di registrazione dell&#x27;utente da aggiungere.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public registerUser(body: UserRegistrationForm, observe?: 'body', reportProgress?: boolean): Observable<User>;
    public registerUser(body: UserRegistrationForm, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<User>>;
    public registerUser(body: UserRegistrationForm, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<User>>;
    public registerUser(body: UserRegistrationForm, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling registerUser.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<User>('post',`${this.basePath}/api/v1/user/registration`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Annulla la procedura di reset-password a partire dal token fornito tramite email.
     * Invocata da utente tramite link ricevuto via mail. Invalida il token di reset password senza modificare la password. Endpoint pubblico, non richiede autenticazione.
     * @param token Token fornito tramite mail
     * @param X_recaptcha_token Token reCAPTCHA
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetNotMe(token: string, X_recaptcha_token?: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public resetNotMe(token: string, X_recaptcha_token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public resetNotMe(token: string, X_recaptcha_token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public resetNotMe(token: string, X_recaptcha_token?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling resetNotMe.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;
        if (X_recaptcha_token !== undefined && X_recaptcha_token !== null) {
            headers = headers.set('X-recaptcha-token', String(X_recaptcha_token));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/user/reset-not-me`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Richiede il reset della password dell&#x27;utente.
     * Avvia il processo di reset password per l&#x27;utente con l&#x27;email specificata, inviando un link via email. Endpoint pubblico, non richiede autenticazione.
     * @param email 
     * @param X_recaptcha_token Token reCAPTCHA
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetUserPasswordForm(email: string, X_recaptcha_token?: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public resetUserPasswordForm(email: string, X_recaptcha_token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public resetUserPasswordForm(email: string, X_recaptcha_token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public resetUserPasswordForm(email: string, X_recaptcha_token?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling resetUserPassword.');
        }


        let headers = this.defaultHeaders;
        if (X_recaptcha_token !== undefined && X_recaptcha_token !== null) {
            headers = headers.set('X-recaptcha-token', String(X_recaptcha_token));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (email !== undefined) {
            formParams = formParams.append('email', <any>email) as any || formParams;
        }

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/user/reset-password`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account Amministratore di inviare una mail di comunicazione generica GENITORE di un comune
     * Invia una email di comunicazione generica a tutti i genitori del comune specificato, con possibilità di allegare file.
     * @param slugComune 
     * @param comunicazionGenitoriForm 
     * @param files 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendEmailComunicazioneGenitoriForm(slugComune: string, comunicazionGenitoriForm?: ComunicazionGenitoriForm, files?: Array<Blob>, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public sendEmailComunicazioneGenitoriForm(slugComune: string, comunicazionGenitoriForm?: ComunicazionGenitoriForm, files?: Array<Blob>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public sendEmailComunicazioneGenitoriForm(slugComune: string, comunicazionGenitoriForm?: ComunicazionGenitoriForm, files?: Array<Blob>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public sendEmailComunicazioneGenitoriForm(slugComune: string, comunicazionGenitoriForm?: ComunicazionGenitoriForm, files?: Array<Blob>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling sendEmailComunicazioneGenitori.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (comunicazionGenitoriForm !== undefined) {
            formParams = formParams.append('comunicazionGenitoriForm', <any>comunicazionGenitoriForm) as any || formParams;
        }
        if (files) {
            files.forEach((element) => {
                formParams = formParams.append('files', <any>element) as any || formParams;
            })
        }

        return this.httpClient.request<GenericResponseDTO>('post',`${this.basePath}/api/v1/user/genitori/send-comunicazione-email`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account Amministratore di inviare un sms di comunicazione generica GENITORE di un comune
     * Invia un SMS di comunicazione generica ai genitori del comune specificato, con possibilità di filtrare i destinatari tramite il parametro &#x27;filter&#x27;.
     * @param body 
     * @param slugComune 
     * @param filter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendSmsComunicazioneGenitori(body: string, slugComune: string, filter: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public sendSmsComunicazioneGenitori(body: string, slugComune: string, filter: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public sendSmsComunicazioneGenitori(body: string, slugComune: string, filter: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public sendSmsComunicazioneGenitori(body: string, slugComune: string, filter: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling sendSmsComunicazioneGenitori.');
        }

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling sendSmsComunicazioneGenitori.');
        }

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling sendSmsComunicazioneGenitori.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'text/plain'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/user/genitori/send-comunicazione-sms`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di aggiornare il push token.
     * Aggiorna o registra il token Firebase per le notifiche push dell&#x27;utente autenticato.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePushToken(body: PushTokenDTO, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public updatePushToken(body: PushTokenDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public updatePushToken(body: PushTokenDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public updatePushToken(body: PushTokenDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updatePushToken.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/user/updatePushToken`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un ADMIN o OP_COMUNE di aggiornare lo storico ISEE di una anagrafica e ricalcolare i costi pasto degli studenti associati.
     * Aggiorna la fascia ISEE dell&#x27;anagrafica e ricalcola automaticamente il costo pasto per tutti gli studenti collegati. Accessibile agli utenti ADMIN e OP_COMUNE.
     * @param body 
     * @param anagrafica_id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateStoricoIsee(body: UpdateStoricoIseeForm, anagrafica_id: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public updateStoricoIsee(body: UpdateStoricoIseeForm, anagrafica_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public updateStoricoIsee(body: UpdateStoricoIseeForm, anagrafica_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public updateStoricoIsee(body: UpdateStoricoIseeForm, anagrafica_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateStoricoIsee.');
        }

        if (anagrafica_id === null || anagrafica_id === undefined) {
            throw new Error('Required parameter anagrafica_id was null or undefined when calling updateStoricoIsee.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/user/${encodeURIComponent(String(anagrafica_id))}/storico-isee`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Aggiorna la password dell&#x27;utente.
     * Imposta la nuova password per l&#x27;utente tramite il token ricevuto via email durante il processo di reset. Endpoint pubblico, non richiede autenticazione.
     * @param token 
     * @param password 
     * @param X_recaptcha_token Token reCAPTCHA
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUserPasswordForm(token: string, password: string, X_recaptcha_token?: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public updateUserPasswordForm(token: string, password: string, X_recaptcha_token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public updateUserPasswordForm(token: string, password: string, X_recaptcha_token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public updateUserPasswordForm(token: string, password: string, X_recaptcha_token?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling updateUserPassword.');
        }

        if (password === null || password === undefined) {
            throw new Error('Required parameter password was null or undefined when calling updateUserPassword.');
        }


        let headers = this.defaultHeaders;
        if (X_recaptcha_token !== undefined && X_recaptcha_token !== null) {
            headers = headers.set('X-recaptcha-token', String(X_recaptcha_token));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (token !== undefined) {
            formParams = formParams.append('token', <any>token) as any || formParams;
        }
        if (password !== undefined) {
            formParams = formParams.append('password', <any>password) as any || formParams;
        }

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/user/update-password`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verifica un nuovo account a partire dal token ricevuto via mail dopo la registrazione e setta la sua password.
     * Completa la verifica dell&#x27;account impostando la password iniziale tramite il token ricevuto via email al momento della registrazione. Endpoint pubblico, non richiede autenticazione.
     * @param token 
     * @param password 
     * @param X_recaptcha_token Token reCAPTCHA
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public verifyAccountForm(token?: string, password?: string, X_recaptcha_token?: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public verifyAccountForm(token?: string, password?: string, X_recaptcha_token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public verifyAccountForm(token?: string, password?: string, X_recaptcha_token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public verifyAccountForm(token?: string, password?: string, X_recaptcha_token?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (X_recaptcha_token !== undefined && X_recaptcha_token !== null) {
            headers = headers.set('X-recaptcha-token', String(X_recaptcha_token));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (token !== undefined) {
            formParams = formParams.append('token', <any>token) as any || formParams;
        }
        if (password !== undefined) {
            formParams = formParams.append('password', <any>password) as any || formParams;
        }

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/user/verification`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
